import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflow: 'auto',
    },
    table: {
        //minWidth: 700,
        maxHeight: "40vh",
        overflow: 'auto',
    },
});

let id = 0;
function createData(name, details) {
    id += 1;
    return { name, details };
}

const rows = [
    createData('Purchase Order ID', 'OE11000660'),
    createData('Purchase Order Line Item', '15'),
    createData('Created By', 'Yeo Tai Yiap'),
    createData('Created Date', '14-SEP-18 16:00:02'),    
    createData('Created Time', 'NULL'),    
    createData('Changed By', 'NULL'),    
    createData('Changed Date', 'NULL'),    
    createData('Changed Time', 'NULL'),    
    createData('Requisitioner', 'NULL'),    
    createData('Document Date', 'NULL'),    
    createData('Deleted Flag', 'NULL'),    
    createData('Hold Flag', 'NULL'),    
    createData('Void Flag', 'NULL'),    
    createData('Legal Entity Code', 'ABC Pte Lte'),    
    createData('Cost Center Code', 'ABC Pte Lte'),    
    createData('Purchase Organization Code', '8888'),    
    createData('Account ID', 'NULL'),    
    createData('Project ID', 'NULL'),    
    createData('Vendor Name', 'E SERVICES SINGAPORE PTE. LED.'),    
    createData('Vendor ID', '010002038'),    
    createData('Approved By', 'Ong Hung Eng Simon'),    
    createData('Approved By ID', 'XXXX6983E'),    
    createData('Approved Date', 'NULL'),    
    createData('Approved Time', 'NULL'),    
    createData('Payment Terms', 'NULL'),    
    createData('Delivery Address', 'NULL'),    
    createData('Delivery City', 'NULL'),    
    createData('Delivery State', 'NULL'),    
    createData('Delivery Zip', 'NULL'),    
    createData('Purchase Order Status', 'NULL'),    
    createData('Comment', 'Multi_Pair cables Cat3'),    
    createData('Material ID', 'NULL'),    
    createData('Quantity', '90'),    
    createData('Amount Gorss', '1125'),    
    createData('Amount Net', 'NULL'),    
    createData('Currency Type', 'SGD'),    
    createData('Unit Of Measure', 'EA'),    
    createData('Tax Rate', 'NULL'),    
    createData('Tax Amount', 'NULL'),    
    createData('PO Type', 'E CAT. CATALOGUE BUY'),    
    createData('Status', 'Order has been issued'),    
    createData('Period Contract Code', 'IDA00ECN08000004'),    
    createData('Tender Ref', 'NULL'),    
    createData('Parent Document Number', 'SLA00EPR1100235')
];

class TransactionDetailTable extends Component {
    state = {
        value: "open"
    }
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    render() {
        const classes = this.props;
        const statusSelect = (<Select
            value={this.state.value}
            onChange={this.handleChange}
            inputProps={{
                name: 'value',
                id: 'age-simple',
            }}
        >
            <MenuItem value={"open"}>Open</MenuItem>
            <MenuItem value={"review"}>In Review</MenuItem>
            <MenuItem value={"closed"}>Closed</MenuItem>
            <MenuItem value={"escalated"}>Escalated</MenuItem>
        </Select>)
        return (
            <div className={classes.root}>

                <Table className={classes.table}>
                    <TableBody>
                        
                        {rows.map(row => {
                            return (
                                <TableRow key={row.id}>
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.details}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        )
    }
}

TransactionDetailTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TransactionDetailTable);


// WEBPACK FOOTER //
// ./src/components/Transactions/TransactionDetailTable.js